export default __webpack_public_path__ + "static/media/IconWoman.d07b3bba.svg";